import React, { useEffect, useState } from 'react';
import { Button, Text, TextInput, View } from "../../Components/Themed"
import type { PlayerBracketProps } from "../../types"
import { BracketComeptitionApi } from '../api';
import { Modal } from 'react-native';

type EditPlayerBracketProps = {
    player_bracket?:PlayerBracketProps,
    view_mode?:'desktop'|'mobile',
    insets?:{ top:number, bottom:number, left:number, right:number },
    onUpdatePlayerBracket:(pb:PlayerBracketProps) => void,
    onFocusPosition?:(data:{ x:number, y:number, height:number, width:number }) => void,
    onClose:() => void
}
const EditPlayerBracket = ({ player_bracket, view_mode, onUpdatePlayerBracket, onFocusPosition, insets, onClose }:EditPlayerBracketProps) => {
    const [ draft_pb, setDraftPb ] = useState(player_bracket);
    const [ action_loading, setActionLoading ] = useState(false);

    useEffect(() => {
        setDraftPb(player_bracket)
    },[player_bracket])

    const is_changed = JSON.stringify(draft_pb) != JSON.stringify(player_bracket) ? true : false

    const handleUpdate = async() => {
        if(action_loading || !draft_pb){ return }
        setActionLoading(true);
        let new_pb = await BracketComeptitionApi.updatePlayerBracket(draft_pb)
        setActionLoading(false);
        onUpdatePlayerBracket(new_pb)
    }

    const handleDelete = async() => {
        if(action_loading || !draft_pb){ return }
        setActionLoading(true);
        let new_pb = await BracketComeptitionApi.deletePlayerBracket(draft_pb.player_bracket_id);
        console.log(new_pb)
        setActionLoading(false);
        onUpdatePlayerBracket(new_pb)
    }

    if(!player_bracket || !draft_pb){ return <></> }

    return (
        <Modal
            visible={player_bracket ? true : false}
            style={{ flex:1 }}
            transparent
            animationType={view_mode == 'desktop' ? 'fade' : 'slide'}
        >
            <View type='blur' style={view_mode == 'desktop' ? { flex:1, justifyContent:'center', alignItems:'center' } : { flex:1, justifyContent:'flex-end', paddingBottom:(insets?.bottom ?? 0)}}>
                <View float style={view_mode == 'desktop' ? { width:500 }:{ margin:10 }}>
                    <View type='header' style={{ flexDirection:'row', alignItems:'center', padding:10, borderTopRightRadius:8, borderTopLeftRadius:8 }}>
                        <View transparent style={{ flex:1 }}>
                            <Text theme='h1'>EDIT MY BRACKET</Text>
                            <Text style={{ marginTop:3 }} theme='description'>{player_bracket.bracket_name}</Text>
                        </View>
                        <Button
                            title='DELETE'
                            type='error'
                            loading={action_loading}
                            style={{ padding:10, opacity:action_loading?0.5:1 }}
                            disabled={action_loading}
                            onPress={() => handleDelete()}
                        />
                    </View>
                    <View type='body' style={{ padding:10 }}>
                        <View>
                            <Text style={{ marginBottom:10 }} theme='h2'>Update Bracket Name</Text>
                            <TextInput
                                value={draft_pb?.bracket_name}
                                onFocusPosition={onFocusPosition}
                                onChangeText={(text) => setDraftPb({ ...draft_pb, bracket_name: text })}
                            />
                        </View>
                    </View>
                    <View type='footer' style={{ flexDirection:'row', padding:10, borderBottomLeftRadius:8, borderBottomRightRadius:8 }}>
                        <Button
                            style={{ flex:1 }}
                            title='CANCEL'
                            type='close'
                            onPress={() => onClose()}
                        />
                        <Button
                            style={{ flex:2, marginLeft:5, opacity: is_changed?1:0.5 }}
                            title='UPDATE'
                            loading={action_loading}
                            type='success'
                            disabled={!is_changed || action_loading}
                            onPress={handleUpdate}
                        />
                    </View>
                </View>
            </View>
        </Modal>
    )
}

export default EditPlayerBracket